import { Input } from "antd";
import styled from "styled-components";

const { Search } = Input;
export const SearchBar = styled(Search)`
  width: 300px;
`;
